import { useEffect } from "react";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";
import { logConsent } from "../utils/logConsent";

const CAT_NECESSARY = "necessary";
const CAT_ANALYTICS = "analytics";

const SERVICE_AD_STORAGE = "ad_storage";
const SERVICE_AD_USER_DATA = "ad_user_data";
const SERVICE_AD_PERSONALIZATION = "ad_personalization";
const SERVICE_ANALYTICS_STORAGE = "analytics_storage";

// Estende o tipo Window para incluir gtag
declare global {
  interface Window {
    gtag?: (
      command: string,
      action: string,
      params: Record<string, string>
    ) => void;
  }
}

const updateGoogleConsent = (): void => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("consent", "update", {
      [SERVICE_ANALYTICS_STORAGE]: CookieConsent.acceptedService(
        SERVICE_ANALYTICS_STORAGE,
        CAT_ANALYTICS
      )
        ? "granted"
        : "denied",
      [SERVICE_AD_STORAGE]: CookieConsent.acceptedService(
        SERVICE_AD_STORAGE,
        CAT_ANALYTICS
      )
        ? "granted"
        : "denied",
      [SERVICE_AD_USER_DATA]: CookieConsent.acceptedService(
        SERVICE_AD_USER_DATA,
        CAT_ANALYTICS
      )
        ? "granted"
        : "denied",
      [SERVICE_AD_PERSONALIZATION]: CookieConsent.acceptedService(
        SERVICE_AD_PERSONALIZATION,
        CAT_ANALYTICS
      )
        ? "granted"
        : "denied",
    });
  }
};

export default function CookieConsentComponent() {
  useEffect(() => {
    CookieConsent.run({
      categories: {
        [CAT_NECESSARY]: {
          enabled: true,
          readOnly: true,
        },
        [CAT_ANALYTICS]: {
          autoClear: {
            cookies: [
              {
                name: /^_ga/,
              },
              {
                name: "_gid",
              },
            ],
          },

          services: {
            [SERVICE_ANALYTICS_STORAGE]: {
              label:
                "Permite armazenamento (como cookies) relacionado a analytics, exemplo: duração da visita.",
            },
            [SERVICE_AD_STORAGE]: {
              label:
                "Permite armazenamento (como cookies) relacionado a publicidade.",
            },
            [SERVICE_AD_USER_DATA]: {
              label:
                "Define consentimento para enviar dados de usuário relacionados a publicidade para o Google.",
            },
            [SERVICE_AD_PERSONALIZATION]: {
              label: "Define consentimento para publicidade personalizada.",
            },
          },
        },
      },

      onFirstConsent: () => {
        logConsent();
        updateGoogleConsent();
      },

      onChange: () => {
        logConsent();
        updateGoogleConsent();
      },

      onConsent: () => {
        updateGoogleConsent();
      },

      language: {
        default: "pt-BR",
        translations: {
          "pt-BR": {
            consentModal: {
              title: "Nós usamos cookies",
              description:
                "Utilizamos cookies para melhorar sua experiência de navegação e analisar o uso do site.",
              acceptAllBtn: "Aceitar todos",
              acceptNecessaryBtn: "Rejeitar todos",
              showPreferencesBtn: "Gerenciar preferências",
            },
            preferencesModal: {
              title: "Gerenciar preferências de cookies",
              acceptAllBtn: "Aceitar todos",
              acceptNecessaryBtn: "Rejeitar todos",
              savePreferencesBtn: "Salvar seleção atual",
              closeIconLabel: "Fechar modal",
              sections: [
                {
                  title: "Sobre os cookies",
                  description:
                    "Os cookies nos ajudam a oferecer uma melhor experiência para você.",
                },
                {
                  title: "Cookies estritamente necessários",
                  description:
                    "Estes cookies são essenciais para o funcionamento adequado do site e não podem ser desabilitados.",
                  linkedCategory: CAT_NECESSARY,
                },
                {
                  title: "Performance e Analytics",
                  description:
                    "Estes cookies coletam informações sobre como você usa nosso site. Todos os dados são anonimizados e não podem ser usados para identificá-lo.",
                  linkedCategory: CAT_ANALYTICS,
                  cookieTable: {
                    headers: {
                      name: "Nome",
                      domain: "Serviço",
                      description: "Descrição",
                      expiration: "Expiração",
                    },
                    body: [
                      {
                        name: "_ga",
                        domain: "Google Analytics",
                        description:
                          'Cookie definido pelo <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
                        expiration: "Expira após 12 dias",
                      },
                      {
                        name: "_gid",
                        domain: "Google Analytics",
                        description:
                          'Cookie definido pelo <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
                        expiration: "Sessão",
                      },
                    ],
                  },
                },
                {
                  title: "Mais informações",
                  description:
                    'Para quaisquer dúvidas sobre nossa política de cookies e suas opções, <a href="/contato">entre em contato conosco</a>.',
                },
              ],
            },
          },
        },
      },
    });
  }, []);

  return null;
}
